import Yup from '@shared/lib/yupWithCustomValidations';
import { sanitizePhoneNumber } from '@shared/util/phoneNumber';

export const userValidationSchema = Yup.object({
  access_code: Yup.string().notBlank(),
  // i18n-tasks-use t('registration.errors.email_must_be_valid')
  email: Yup.string().notBlank().validEmail('registration.errors.email_must_be_valid'),
  password: Yup.string().notBlank().validPassword(),
  phone: Yup.string().notBlank().validPhone(),
  phoneVerificationCode: Yup.string().notBlank(),
});

export const oneTimeCodeValidator = Yup.string().matches(
  /^\d{6}$/,
  // i18n-tasks-use t('error_messages.two_factor_code_missing')
  'error_messages.two_factor_code_missing',
);

export const phoneChecker = Yup.string().validPhone();

// currently a username is either an email address or a fully qualified(international) phone number
export const sanitizeUsername = (username: string) =>
  // this converts Hindu-Arabic numerals so the backend can understand them
  phoneChecker.isValidSync(username) ? sanitizePhoneNumber(username) : username;
